var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_8180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 5.83333H13.3333V4.16667L11.6666 2.5H8.33329L6.66663 4.16667V5.83333H3.33329C2.41663 5.83333 1.66663 6.58333 1.66663 7.5V11.6667C1.66663 12.2917 1.99996 12.8167 2.49996 13.1083V15.8333C2.49996 16.7583 3.24163 17.5 4.16663 17.5H15.8333C16.7583 17.5 17.5 16.7583 17.5 15.8333V13.1C17.9916 12.8083 18.3333 12.275 18.3333 11.6667V7.5C18.3333 6.58333 17.5833 5.83333 16.6666 5.83333ZM8.33329 4.16667H11.6666V5.83333H8.33329V4.16667ZM3.33329 7.5H16.6666V11.6667H12.5V9.16667H7.49996V11.6667H3.33329V7.5ZM10.8333 12.5H9.16663V10.8333H10.8333V12.5ZM15.8333 15.8333H4.16663V13.3333H7.49996V14.1667H12.5V13.3333H15.8333V15.8333Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_8180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenter);
export default __webpack_public_path__ + "static/media/business_center.6753b9a3c8b9d50f0faa2f1988e08186.svg";
export { ForwardRef as ReactComponent };